// REMOVE EVENT LISTENER

import {useEffect} from 'react'
// import {isHeaderInBounds} from './fn'
// import {appContext} from './contexts'


export const isHeaderInBounds = (headerRef, componentRef) => {
    const headerBottom = headerRef.current.getBoundingClientRect().bottom;
    const {top, bottom} = componentRef.current.getBoundingClientRect();
    return headerBottom > top && headerBottom < bottom
}

export const useHeaderChecker = (context) => {
    const componentRefs = [context.aboutRef, context.contactRef, context.projectsRef]
    const headerRef = context.headerRef;
    useEffect(() => {
        const checkComponents = () => {
            componentRefs.forEach(ref => {
                if(isHeaderInBounds(headerRef, ref)){
                        context.dispatch({type: "mode", payload: ref.current.id});
                }
            })
        }
        console.log("adding event listener")
        checkComponents()
        window.addEventListener('scroll', checkComponents)

        return () => {
            console.log("removing event listener")
            window.removeEventListener('scroll', checkComponents)
        }
    }, [])

}

export const appReducer = (state, action) => {
    // console.log(action)
    switch(action.type){
      case "mode": 
    //   console.log("reducer payload:", action.payload)
        const newState =  {
            ...state,
            mode: action.payload
        }
        // console.log("new State", newState)
        return newState
      ;
      default: return state
    }
  }

  export const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.toLowerCase().slice(1)
  }

  export const ABOUT = "ABOUT"
  export const CONTACT = "CONTACT"
  export const PROJECTS = "PROJECTS"
  export const MEDIA = "MEDIA"

